/*
 * HOUSE OF VELORIEN. Product page redesign (PDP)
 * Progressive enhancement only. Every interaction here has a working
 * no-JS fallback: colour/option links are real `?variant=` URLs, the
 * add-to-bag form is a native Shopify product form, and the gallery
 * server-renders the selected colour's photos directly.
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-hpr-root]');
  if (!root) return;

  var productJsonEl = root.querySelector('[data-hpr-product-json]');
  var product = null;
  try {
    product = productJsonEl ? JSON.parse(productJsonEl.textContent) : null;
  } catch (e) {
    product = null;
  }

  var currency = root.getAttribute('data-currency') || '£';
  var colourPosition = parseInt(root.getAttribute('data-colour-option-position'), 10) || 0;

  var media = root.querySelector('[data-hpr-media]');
  var gallery = root.querySelector('[data-hpr-gallery]');
  var templatesWrap = root.querySelector('[data-hpr-gallery-templates]');
  var dotsWrap = root.querySelector('[data-hpr-dots]');
  var countEl = root.querySelector('[data-hpr-count]');

  function money(cents) {
    if (typeof cents !== 'number') return '';
    var amount = (cents / 100).toFixed(2);
    if (amount.slice(-3) === '.00') amount = amount.slice(0, -3);
    return currency + amount;
  }

  /* ---------------- Gallery: colour swap via pre-rendered <template> ---------------- */

  function galleryPhotos() {
    return gallery ? Array.prototype.slice.call(gallery.querySelectorAll('.hpr__photo')) : [];
  }

  function syncCarouselMeta() {
    var photos = galleryPhotos();
    var total = photos.length;
    if (countEl) {
      countEl.textContent = '1 / ' + total;
    }
    if (dotsWrap) {
      dotsWrap.innerHTML = '';
      for (var i = 0; i < total; i++) {
        var dot = document.createElement('span');
        dot.className = 'hpr__dot' + (i === 0 ? ' hpr__dot--active' : '');
        dotsWrap.appendChild(dot);
      }
    }
    if (gallery) gallery.scrollLeft = 0;
  }

  function updateCarouselPosition() {
    if (!gallery) return;
    var photos = galleryPhotos();
    if (!photos.length) return;
    var width = gallery.clientWidth || 1;
    var index = Math.round(gallery.scrollLeft / width);
    index = Math.max(0, Math.min(index, photos.length - 1));
    if (countEl) countEl.textContent = (index + 1) + ' / ' + photos.length;
    if (dotsWrap) {
      var dots = dotsWrap.querySelectorAll('.hpr__dot');
      dots.forEach(function (dot, i) {
        dot.classList.toggle('hpr__dot--active', i === index);
      });
    }
  }

  if (gallery) {
    var scrollTimer;
    gallery.addEventListener(
      'scroll',
      function () {
        window.clearTimeout(scrollTimer);
        scrollTimer = window.setTimeout(updateCarouselPosition, 80);
      },
      { passive: true }
    );
  }

  function cssEscape(value) {
    if (window.CSS && window.CSS.escape) return window.CSS.escape(value);
    return String(value).replace(/["\\]/g, '\\$&');
  }

  function colourTemplate(colour) {
    if (!templatesWrap || !colour) return null;
    return templatesWrap.querySelector(
      '[data-hpr-colour-template][data-colour="' + cssEscape(colour) + '"]'
    );
  }

  /* Snapshot the server-rendered landing gallery so switching away and back
     still restores the starting colour (Liquid also emits a template for every
     colour now; this covers older HTML / edge cases). */
  function ensureColourTemplate(colour) {
    if (!gallery || !templatesWrap || !colour) return;
    if (colourTemplate(colour)) return;
    var tpl = document.createElement('template');
    tpl.setAttribute('data-hpr-colour-template', '');
    tpl.setAttribute('data-colour', colour);
    Array.prototype.slice.call(gallery.childNodes).forEach(function (node) {
      tpl.content.appendChild(node.cloneNode(true));
    });
    templatesWrap.appendChild(tpl);
  }

  function swapGalleryForColour(colour) {
    if (!gallery || !templatesWrap) return false;
    var tpl = colourTemplate(colour);
    if (!tpl) return false;
    gallery.innerHTML = '';
    gallery.appendChild(tpl.content.cloneNode(true));
    syncCarouselMeta();
    return true;
  }

  var initialColour = root.getAttribute('data-current-colour') || '';
  ensureColourTemplate(initialColour);

  /* ---------------- Lightbox ---------------- */

  var lightbox = root.querySelector('[data-hpr-lightbox]');
  var lightboxStage = lightbox ? lightbox.querySelector('[data-hpr-lightbox-stage]') : null;
  var lightboxCount = lightbox ? lightbox.querySelector('[data-hpr-lightbox-count]') : null;
  var lightboxIndex = 0;

  function lightboxPhotos() {
    return galleryPhotos();
  }

  function renderLightbox() {
    var photos = lightboxPhotos();
    if (!photos.length || !lightboxStage) return;
    lightboxIndex = ((lightboxIndex % photos.length) + photos.length) % photos.length;
    var photo = photos[lightboxIndex];
    var full = photo.getAttribute('data-full');
    var img = photo.querySelector('img');
    var alt = img ? img.alt : '';
    lightboxStage.innerHTML = '';
    var tag = document.createElement('img');
    tag.src = full || (img ? img.currentSrc || img.src : '');
    tag.alt = alt;
    lightboxStage.appendChild(tag);
    if (lightboxCount) lightboxCount.textContent = (lightboxIndex + 1) + ' / ' + photos.length;
  }

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function openLightbox(index) {
    if (!lightbox) return;
    lightboxIndex = index || 0;
    renderLightbox();
    lightbox.hidden = false;
    lightbox.classList.remove('is-leaving');
    document.documentElement.style.overflow = 'hidden';
    if (reduceMotion) {
      lightbox.classList.add('is-visible');
    } else {
      window.requestAnimationFrame(function () {
        lightbox.classList.add('is-visible');
      });
    }
    var closeBtn = lightbox.querySelector('[data-hpr-lightbox-close]');
    if (closeBtn) closeBtn.focus();
  }

  function closeLightbox() {
    if (!lightbox || lightbox.hidden) return;
    document.documentElement.style.overflow = '';
    if (reduceMotion) {
      lightbox.classList.remove('is-visible', 'is-leaving');
      lightbox.hidden = true;
      return;
    }
    lightbox.classList.add('is-leaving');
    lightbox.classList.remove('is-visible');
    var settled = false;
    var finish = function () {
      if (settled) return;
      settled = true;
      lightbox.classList.remove('is-leaving');
      lightbox.hidden = true;
    };
    lightbox.addEventListener('transitionend', finish, { once: true });
    window.setTimeout(finish, 240);
  }

  if (lightbox) {
    lightbox.addEventListener('click', function (event) {
      var closeBtn = event.target.closest('[data-hpr-lightbox-close]');
      var prevBtn = event.target.closest('[data-hpr-lightbox-prev]');
      var nextBtn = event.target.closest('[data-hpr-lightbox-next]');
      if (closeBtn || event.target === lightbox) {
        closeLightbox();
      } else if (prevBtn) {
        lightboxIndex -= 1;
        renderLightbox();
      } else if (nextBtn) {
        lightboxIndex += 1;
        renderLightbox();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (lightbox.hidden) return;
      if (event.key === 'Escape') closeLightbox();
      if (event.key === 'ArrowLeft') {
        lightboxIndex -= 1;
        renderLightbox();
      }
      if (event.key === 'ArrowRight') {
        lightboxIndex += 1;
        renderLightbox();
      }
    });

    var touchStartX = null;
    lightboxStage &&
      lightboxStage.addEventListener(
        'touchstart',
        function (event) {
          touchStartX = event.touches[0].clientX;
        },
        { passive: true }
      );
    lightboxStage &&
      lightboxStage.addEventListener(
        'touchend',
        function (event) {
          if (touchStartX === null) return;
          var dx = event.changedTouches[0].clientX - touchStartX;
          if (Math.abs(dx) > 40) {
            lightboxIndex += dx < 0 ? 1 : -1;
            renderLightbox();
          }
          touchStartX = null;
        },
        { passive: true }
      );
  }

  /* Delegated clicks for zoom / photo-open / show-all, so gallery swaps
     (innerHTML replace) never need re-binding. */
  if (media) {
    media.addEventListener('click', function (event) {
      var openEl = event.target.closest('[data-hpr-open-lightbox]');
      if (openEl) {
        var idx = parseInt(openEl.getAttribute('data-hpr-index'), 10) || 0;
        openLightbox(idx);
        return;
      }
      var showAll = event.target.closest('[data-hpr-show-all]');
      if (showAll && gallery) {
        gallery.classList.add('hpr__gallery--expanded');
      }
    });
  }

  /* ---------------- Colour swatches + option pills: instant variant swap ---------------- */

  function findVariantById(id) {
    if (!product) return null;
    return (product.variants || []).find(function (v) {
      return String(v.id) === String(id);
    });
  }

  function updatePriceUI(variant) {
    var priceRow = root.querySelector('[data-hpr-price-row]');
    if (!priceRow || !variant) return;
    var compare = variant.compare_at_price;
    var price = variant.price;
    var html = '';
    if (compare && compare > price) {
      var save = money(compare - price);
      html +=
        '<span class="hpr__price hpr__price--sale">' + money(price) + '</span>' +
        '<span class="hpr__compare">' + money(compare) + '</span>' +
        '<span class="hpr__save">Save ' + save + '</span>';
    } else {
      html += '<span class="hpr__price">' + money(price) + '</span>';
    }
    priceRow.innerHTML = html;
  }

  function updateStockUI(variant) {
    var stock = root.querySelector('[data-hpr-stock]');
    var stockText = root.querySelector('[data-hpr-stock-text]');
    if (!stock || !variant) return;
    var available = !!variant.available;
    stock.classList.toggle('hpr__stock--soldout', !available);
    if (stockText) stockText.textContent = available ? 'In stock' : 'Sold out in this colour';

    var lowStock = root.querySelector('[data-hpr-low-stock]');
    var lowStockQty = root.querySelector('[data-hpr-low-stock-qty]');
    if (!lowStock) return;
    var tracked = variant.inventory_management != null && variant.inventory_management !== '';
    var qty = typeof variant.inventory_quantity === 'number' ? variant.inventory_quantity : null;
    var showLow = tracked && qty != null && qty > 0 && qty <= 5;
    if (showLow) {
      if (lowStockQty) lowStockQty.textContent = String(qty);
      lowStock.hidden = false;
      lowStock.removeAttribute('hidden');
    } else {
      lowStock.hidden = true;
      lowStock.setAttribute('hidden', '');
    }
  }

  function updateAddButtonUI(variant) {
    var addBtn = root.querySelector('[data-hpr-add]');
    var addText = root.querySelector('[data-hpr-add-text]');
    var dockAdd = document.querySelector('[data-hpr-dock-add]');
    var available = !!(variant && variant.available);
    if (addBtn) addBtn.disabled = !available;
    if (addText) addText.textContent = available ? 'Add to bag' : 'Sold out';
    if (dockAdd) dockAdd.disabled = !available;
  }

  function updateDockUI(variant) {
    var dockPriceCurrent = document.querySelector('[data-hpr-dock-price-current]');
    var dockPriceCompare = document.querySelector('[data-hpr-dock-price-compare]');
    if (!variant) return;
    var compare = variant.compare_at_price;
    var price = variant.price;
    if (dockPriceCurrent) {
      dockPriceCurrent.textContent = money(price);
      dockPriceCurrent.classList.toggle('hpr-dock__price-current--sale', !!(compare && compare > price));
    }
    if (dockPriceCompare) {
      if (compare && compare > price) {
        dockPriceCompare.textContent = money(compare);
        dockPriceCompare.hidden = false;
      } else {
        dockPriceCompare.hidden = true;
      }
    }
  }

  function updateUrl(variant) {
    if (!variant || !window.history || !window.history.replaceState) return;
    try {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', String(variant.id));
      window.history.replaceState({}, '', url.pathname + url.search + url.hash);
    } catch (e) {}
  }

  function updateColourLabel(colour) {
    var label = root.querySelector('[data-hpr-colour-value]');
    if (label && colour) label.textContent = colour;
  }

  function updateSelectedSwatch(colour) {
    var swatches = root.querySelectorAll('[data-hpr-colour-link]');
    swatches.forEach(function (el) {
      el.classList.toggle('hpr__swatch--selected', el.getAttribute('data-colour') === colour);
    });
  }

  function applyVariant(variant, colour) {
    if (!variant) return;
    var idInput = root.querySelector('[data-hpr-variant-id]');
    if (idInput) idInput.value = variant.id;
    updatePriceUI(variant);
    updateStockUI(variant);
    updateAddButtonUI(variant);
    updateDockUI(variant);
    updateUrl(variant);
    if (colour) updateColourLabel(colour);
  }

  root.addEventListener('click', function (event) {
    var colourLink = event.target.closest('[data-hpr-colour-link]');
    if (colourLink) {
      var colour = colourLink.getAttribute('data-colour');
      var variantId = colourLink.getAttribute('data-variant-id');
      var variant = findVariantById(variantId);
      if (!variant) return; // fall back to native navigation
      event.preventDefault();
      updateSelectedSwatch(colour);
      swapGalleryForColour(colour);
      applyVariant(variant, colour);
      return;
    }

    var optionLink = event.target.closest('[data-hpr-option-link]');
    if (optionLink) {
      var variantId2 = optionLink.getAttribute('data-variant-id');
      var variant2 = findVariantById(variantId2);
      if (!variant2) return;
      event.preventDefault();
      var group = optionLink.closest('[data-hpr-option-values]');
      if (group) {
        group.querySelectorAll('[data-hpr-option-link]').forEach(function (el) {
          el.classList.toggle('hpr__option-pill--selected', el === optionLink);
        });
      }
      applyVariant(variant2, null);
    }
  });

  /* ---------------- Quantity stepper ---------------- */

  var qtyInput = root.querySelector('[data-hpr-qty]');
  var qtyMinus = root.querySelector('[data-hpr-qty-minus]');
  var qtyPlus = root.querySelector('[data-hpr-qty-plus]');
  if (qtyMinus && qtyInput) {
    qtyMinus.addEventListener('click', function () {
      var val = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
      qtyInput.value = val;
    });
  }
  if (qtyPlus && qtyInput) {
    qtyPlus.addEventListener('click', function () {
      var val = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + 1);
      qtyInput.value = val;
    });
  }

  /* ---------------- Add to bag (AJAX, native form fallback) ---------------- */

  function updateCartCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        var count = cart.item_count || 0;
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = count;
          el.style.display = count > 0 ? '' : 'none';
          if (count > 0) el.removeAttribute('aria-hidden');
          else el.setAttribute('aria-hidden', 'true');
        });
        document.querySelectorAll('[data-cart-trigger]').forEach(function (trigger) {
          trigger.setAttribute('aria-label', 'Shopping bag with ' + count + ' items');
        });
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
      })
      .catch(function () {});
  }

  function addToBag(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: quantity || 1 })
    }).then(function (res) {
      if (!res.ok) throw new Error('Add to bag failed');
      return res.json();
    });
  }

  function showAddedToBag() {
    if (typeof window.hovShowAddedToBag === 'function') {
      window.hovShowAddedToBag();
    }
  }

  var form = root.querySelector('[data-hpr-form]');
  var addBtn = root.querySelector('[data-hpr-add]');
  var addText = root.querySelector('[data-hpr-add-text]');
  var variantInput = root.querySelector('[data-hpr-variant-id]');

  if (form && addBtn) {
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (addBtn.disabled) return;
      var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      addBtn.disabled = true;
      if (addText) addText.textContent = 'Adding...';

      addToBag(variantInput ? variantInput.value : null, qty)
        .then(function () {
          addBtn.classList.add('is-success');
          if (addText) addText.textContent = 'Added to bag';
          updateCartCount();
          showAddedToBag();
          window.setTimeout(function () {
            addBtn.classList.remove('is-success');
            addBtn.disabled = false;
            if (addText) addText.textContent = 'Add to bag';
          }, 1600);
        })
        .catch(function () {
          addBtn.disabled = false;
          if (addText) addText.textContent = 'Try again';
          window.setTimeout(function () {
            if (addText) addText.textContent = 'Add to bag';
          }, 1600);
        });
    });
  }

  /* ---------------- Mobile sticky dock ---------------- */

  var dock = document.querySelector('[data-hpr-dock]');
  var dockAddBtn = document.querySelector('[data-hpr-dock-add]');

  if (dock && addBtn && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var show = !entry.isIntersecting;
          dock.hidden = !show;
          if (show) {
            window.requestAnimationFrame(function () {
              dock.classList.add('is-visible');
            });
          } else {
            dock.classList.remove('is-visible');
          }
        });
      },
      { threshold: 0, rootMargin: '0px 0px -8px 0px' }
    );
    observer.observe(addBtn);
  }

  if (dockAddBtn) {
    dockAddBtn.addEventListener('click', function () {
      if (dockAddBtn.disabled) return;
      dockAddBtn.disabled = true;
      addToBag(variantInput ? variantInput.value : null, 1)
        .then(function () {
          updateCartCount();
          showAddedToBag();
          dockAddBtn.disabled = false;
        })
        .catch(function () {
          dockAddBtn.disabled = false;
        });
    });
  }

  /* ---------------- Init ---------------- */

  syncCarouselMeta();
})();
